import { erpApi } from "@/shared/axios";
import { ROUTER_PATHS, urlBackend } from "@/shared/constants";
import { AlertSeverityEnum, UseMutationsParams } from "@/shared/interfaces";
import { ISolicitudEvento, ISolicitudEventoParams, ISolicitudEventoResp } from "@/shared/interfaces/erp/marketing/solicitudEvento.interface";
import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const { get, post, put } = erpApi()
//* get
export const useFetchSolicitudEvento = (
  params: ISolicitudEventoParams,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ['solicitudEvento', ...Object.values(params || {})],
    queryFn: async () => {
      return await getSolicitudEvento(params ?? {})
    },
    enabled
  })
}

export const getSolicitudEvento = async (data: ISolicitudEventoParams) => {
  const queryParams = getUrlParamsFetch(data || {})
  return await get<ISolicitudEventoResp>(`${urlBackend}api/v1/solicitudevento/?${queryParams}`, true);
}
//*get Buscar solictud Evento por id
export const useFetchGetByIdSolicitudEvento = (
  id: string
) => {
  return useQuery({
    queryKey: ['solicitudEvento', id],
    queryFn: async () => {
      return await getByIdSolicitudEvento(id)
    }
  })
}
export const getByIdSolicitudEvento = async (id: string) => {
  return await get(`${urlBackend}api/v1/solicitudevento/${id}/`, true)
}
//* crear una solicitud de evento
export const useFetchPostSolicitudEvento = (
  {
    enableSuccessAlert=true,
    navigate,
    enableRedirect = true,
    returnUrl,
  }: UseMutationsParams
) => {
  const queryClient = useQueryClient()
  const setAlert = useUiStore(s => s.setAlert);
  return useMutation({
    mutationFn: postSolicitudEvento,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['solicitudevento'] })

      enableSuccessAlert
        && setAlert(true, data.message, AlertSeverityEnum.success)

      navigate && enableRedirect && navigate(returnUrl ?? ROUTER_PATHS.marketing.solicitudesCanjeEventoNav) //CAMBIAR LA RUTA
    },
    onError: (error) => handleAxiosError(error)
  })
}
export const postSolicitudEvento = async (data: ISolicitudEventoParams) => {
  return await post<ISolicitudEvento>(`${urlBackend}api/v1/solicitudevento/`, data, true)
}
//*actualizar solicitud de evento
export const useFetchPutSolicitudEvento = (
  {
    enableSuccessAlert,
    navigate,
    returnUrl
  }: UseMutationsParams
) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore(s => s.setAlert);
  return useMutation({
    mutationFn: putSolicitudEvento,
    onSuccess:(data)=>{
       queryClient.invalidateQueries({queryKey:['solicitudevento', data.data.id_solicitud_evento]})
       enableSuccessAlert
       && setAlert(true, data.message, AlertSeverityEnum.success)
       navigate && returnUrl && navigate(returnUrl)
    },
    onError:(error) => handleAxiosError(error)
  })
}
export const putSolicitudEvento = async (data: ISolicitudEventoParams) => {
  return await put<ISolicitudEvento>(`${urlBackend}api/v1/solicitudevento/${data.id_solicitud_evento}/`, data, true)
}